import api from '@/api/index'
import { openDB, cursorGetDataByIndex } from '@/db/index'
export default {
    setUpdateUserInfo(context, data) {
        context.commit('SET_UPDATE_USERINFO', data)
    },
    setToken(context, data){
        context.commit('SET_TOKEN', data)
    },
    setChatType(context, data){
        context.commit('SET_CHAT_TYPE', data)
    },
    setAppTemplate(context,obj){
        context.commit('SET_APPTEMPLATE', obj)
    },
    setChatConfig(context,obj){
        context.commit('SET_CHAT_CONFIG', obj)
    },
    setMyTemplateList(context,list){
        context.commit('SET_MY_TEMPLATE_LIST',list)
    },
    setChatTemplate(context,obj){
        context.commit('SET_CHAT_TEMPLATE',obj)
    },
    setIsLogin(context,bool){
        context.commit('SET_ISLOGIN',bool)
    },
    // 获取示例问题
    async getDemoQuestionsList(context){
        try {
            let res = await api.getDemoQuestions()
            if(res.success){
                context.commit('SET_DEMO_QUESTIONS_LIST',res.data)
            }
          } catch (error) {}
    },
    // 获取绘画样式风格类型
    async getImageStyles(context,params){
        try {
            api.getImageStyles(params).then(res=>{
              if (res.success) {
                context.commit('SET_STYLE_LIST',res.data)
              }
            })
        } catch (error) {}
    },
    // 获取我的任务列表
    async getTasksList(context){
        try {
            api.getTasksV1().then(res=>{
                if (res.success) {
                    context.commit('SET_TASKS_LIST',res.data.filter((v) => v.id != 3))
                } 
            })
        } catch (error) {}
    },
    setCoinRecordDetailList(context,list){
        context.commit('SET_COIN_RECORD_DETAIL_LIST',list)
    },
    async setIndexedDB(context){
        let db = await openDB('webTopchatDBv5')
        context.commit('SET_INDEXEDDB',db)
    }
}